import { formatIndianNumberWithDecimals } from '../../utils/FD/fd'

export default function Factbox({
  regularFundCount,
  additionalCommissionsPaid
}: {
  regularFundCount: number
  additionalCommissionsPaid: number
}) {
  return (
    <div className='flex items-center bg-white rounded-2xl px-5 pb-6 pt-4 shadow-[2px_2px_0_0#992617] z-10 relative mt-6'>
      <div className='flex flex-col text-left'>
        <div className='text-status-text-out-of-form text-[32px] leading-[1]'>{regularFundCount}</div>
        <div className='text-status-text-out-of-form text-[16px] font-medium'>Regular funds</div>
        <div className='text-[#E77464] text-[16px] font-medium leading-[1] mt-2'>
          {formatIndianNumberWithDecimals(additionalCommissionsPaid, 0, true)} paid due to high expense ratio
        </div>
      </div>
    </div>
  )
}
